export const SET_BACKEND_PAYMENT_METHODS = 'SET_BACKEND_PAYMENT_METHODS'
export const SET_AUTHORIZATION_CODE = 'SET_AUTHORIZATION_CODE'
export const SET_GUA_CLIENT_ID = 'SET_GUA_CLIENT_ID'
export const SET_GUA_UA = 'SET_GUA_UA'
export const SET_PARCEL_LOCKER_NO = 'SET_PARCEL_LOCKER_NO'
